module.exports = __webpack_public_path__ + "static/media/chaleco-1.f60f4c9a.png";